import {
    customColumnProps,
    DynamicTable,
} from "@maherunlocker/custom-react-table";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { ToastContainer } from "react-toastify";
import {
    store,
    setIsEdited,
    setIsActionsClicked,
    setActions,
    setValidationAction,
} from "./store";
import { store as storeParent, setIsAddCityAmount } from "../../store";
import CustomIcons from "./CustomIcons";
import CustomSideFilter from "./CustomSideFilter";
import CityAmountForm from "./CityAmountForm";
import { ConfirmationInitializationMessage } from "@components/Common/ConfirmationInitializationMessage";
import { ConfirmationUpdatingDataMessageModal } from "@components/Common/ConfirmationUpdatingDataMessageModal";
import { useCallbackPrompt } from "@hooks/useCallbackPrompt";
import { useAuthHeader } from "../../../../../../api/headersKeycloak";
import { store as storeGlobal } from "@components/VerticalLayout/store";
import { EmptyColumn } from "../shared";

export default function CityAmount({ selectedRowShops }: any) {
    const getAuthHeader = useAuthHeader();
    const { isAddCityAmount } = useSnapshot(storeParent);
    const { franchiseID } = useSnapshot(storeGlobal);

    const {
        isActionsClicked,
        isEdited,
        actions,
        validationAction,
    } = useSnapshot(store);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(
        isEdited
    );
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { t } = useTranslation();
    const [
        isInInitializationModalOpened,
        setIsInInitializationModalOpened,
    ] = React.useState<boolean>(false);
    const [
        isAddNewDeviseButtonClicked,
        setIsAddNewDeviseButtonClicked,
    ] = React.useState(false);
    const [cityData, setCityData] = React.useState<any>([]);
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [selectedRows, setSelectedRows] = React.useState<any[]>([]);
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );

    const urlApi = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/list/city/c&c?franchiseID=${encodeURIComponent(
        franchiseID
    )}&shopId=${encodeURIComponent(
        selectedRowShops[0].id_boutique_order
    )}&amount=true`;

    const arrayOfCustomColumns: customColumnProps[] = useMemo(
        () => [
            {
                indexOFColumn: 999,
                columnName: t("Actions"),
                customJsx: (e: any) => {
                    const tvaValue = e.selectedRow[t("Tva")];
                    if (tvaValue === undefined || tvaValue === null) {
                        return <span></span>;
                    }
                    return (
                        <CustomIcons
                            e={e}
                            setSelectedRows={setSelectedRows}
                            setIsAddCityAmount={setIsAddCityAmount}
                            isAddCityAmount={isAddCityAmount}
                            selectedRowShops={selectedRowShops}
                            setDataIsUpdated={setDataIsUpdated}
                            cityData={cityData}
                        />
                    );
                },
                disableFilter: false,
            },
            {
                indexOFColumn: 3,
                columnName: t("Tva"),
                customJsx: (e: any) => {
                    const tvaValue = e.selectedRow[t("Tva")];
                    if (tvaValue === undefined || tvaValue === null) {
                        return <span></span>;
                    }
                    return <span className="preview-text">{tvaValue}</span>;
                },
            },
        ],
        [
            t,
            setSelectedRows,
            isAddCityAmount,
            selectedRowShops,
            setDataIsUpdated,
            cityData,
        ]
    );

    React.useEffect(() => {
        setActions(confirmNavigation);
        setIsActionsClicked(showPrompt as boolean);
        setValidationAction(cancelNavigation);
    }, [showPrompt, confirmNavigation, cancelNavigation]);

    React.useEffect(() => {
        if (i18nextLng === "fr" || i18nextLng === "en") {
            setDataIsUpdated(true);
        }
    }, [i18nextLng]);

    return (
        <React.Fragment>
            <ToastContainer limit={1} />
            <div
                style={{
                    display: "grid",
                    minHeight: "calc(95vh - 350px)",
                    gridTemplateColumns: isAddCityAmount ? "2fr 1fr " : "auto",
                    gridColumnGap: "4px",
                    border: 0,
                }}
            >
                <DynamicTable
                    url={urlApi}
                    showFilter
                    canSelect={true}
                    setData={setCityData}
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    actionColumn={EmptyColumn}
                    arrayOfCustomColumns={arrayOfCustomColumns}
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    customJsxSideFilterButton={
                        <CustomSideFilter
                            setIsAddCityAmount={setIsAddCityAmount}
                            isAddCityAmount={isAddCityAmount}
                            setLocalFilterActive={setLocalFilterActive}
                            setSelectedRows={setSelectedRows}
                            setIsInInitializationModalOpened={
                                setIsInInitializationModalOpened
                            }
                            isEdited={isEdited}
                            selectedRows={selectedRows}
                        />
                    }
                    showGlobalFilter
                    canExpand
                    elevationTable={1}
                    minHeight={"calc(95vh - 470px)"}
                    maxHeight={"calc(95vh - 460px)"}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    setSelectedRows={setSelectedRows}
                    name="Choice"
                />
                {isAddCityAmount && (
                    <CityAmountForm
                        isAddCityAmount={isAddCityAmount}
                        setIsAddCityAmount={setIsAddCityAmount!}
                        setDataIsUpdated={setDataIsUpdated}
                        setLocalFilterActive={setLocalFilterActive}
                        isAddNewDeviseButtonClicked={
                            isAddNewDeviseButtonClicked
                        }
                        selectedRows={selectedRows}
                        setSelectedRows={setSelectedRows}
                        selectedRowShops={selectedRowShops}
                        cityData={cityData}
                    />
                )}
                {isActionsClicked === true && (
                    <ConfirmationUpdatingDataMessageModal
                        isModalOpened={isActionsClicked}
                        setIsModalOpened={setIsActionsClicked}
                        validationAction={validationAction}
                        actions={actions}
                        setIsEdited={setIsEdited}
                    />
                )}
                {isInInitializationModalOpened === true && (
                    <ConfirmationInitializationMessage
                        isModalOpened={isInInitializationModalOpened}
                        setIsModalOpened={setIsInInitializationModalOpened}
                        setIsClicked={setIsAddNewDeviseButtonClicked}
                        isClicked={isAddNewDeviseButtonClicked}
                        setIsEdited={setIsEdited}
                    />
                )}
            </div>
        </React.Fragment>
    );
}
